import { useEffect, useState } from 'react';
import { api, type Me } from './api';
import { Login } from './pages/Login';
import { AppShell } from './components/AppShell';

type State = { status: 'loading' } | { status: 'login' } | { status: 'app'; me: Me };

export default function App() {
  const [state, setState] = useState<State>({ status: 'loading' });

  useEffect(() => {
    api
      .get<Me>('/api/me')
      .then((me) => setState({ status: 'app', me }))
      .catch(() => setState({ status: 'login' }));
  }, []);

  if (state.status === 'loading') {
    return <div className="container"><p className="muted">Loading…</p></div>;
  }
  if (state.status === 'login') return <Login />;
  return <AppShell me={state.me} />;
}
